module.exports = __webpack_public_path__ + "img/s_6.14529e43.png";